import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'
import {
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function SelectField(props) {
  const { label, name, options, readOnly = false, defaultValue, placeholder = "Select...", ...rest } = props
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const hasValue = field.value || defaultValue;


        return (
          <FormControl fullWidth error={meta.error && meta.touched}>
            <InputLabel
              sx={{
                color: "#9CA3AF",
               // fontWeight: 500,
              //  fontSize: '14px',
                backgroundColor: 'transparent',
                '&.MuiInputLabel-shrink': {
                  backgroundColor: 'transparent',
                }
              }}
              shrink={!!hasValue}
            >
              {hasValue ? placeholder : label}
            </InputLabel>
            <Select
              {...field}
              {...rest}
              label={hasValue ? placeholder : label}
              readOnly={readOnly}
              displayEmpty
              value={field.value || defaultValue || ''}
              IconComponent={KeyboardArrowDownIcon}
              renderValue={selected => {
                if (!selected) {
                  return (
                    <span
                      style={{
                        color: 'grey',
                        opacity: 0.5,
                        fontStyle: 'italic',
                        fontSize: '13px',
                      }}
                    >
                      {placeholder}
                    </span>
                  );
                }
                // Find the selected option's label
                const selectedOption = options.find(opt => opt.value === selected);
                return selectedOption ? selectedOption.key : '';
              }}
              sx={{
                '& .MuiSelect-select': {
                  //  minHeight: '32px', // reduce the select field height
                  padding: '8px 14px',
                  //  fontSize: '15px',
                },
                '& .MuiSelect-icon': {
                  color: 'grey',
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 200, // limit dropdown height
                    '& .MuiMenuItem-root': {
                      //  minHeight: '32px', // reduce dropdown item height
                      // fontSize: '15px',
                    },
                  },
                },
              }}
              InputProps={{
                readOnly: readOnly,
                style: {
                  color: readOnly ? '#333333' : 'inherit',
                  backgroundColor: readOnly ? '#eeeeee' : 'inherit',
                },
              }}
              InputLabelProps={{
                style: {
                  color: readOnly ? '#333333' : 'inherit',
                  backgroundColor: readOnly ? '#eeeeee' : 'inherit',
                },
              }}
            >
              <MenuItem value="" disabled hidden>
                {placeholder}
              </MenuItem>
              {options.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.key}
                </MenuItem>
              ))}
            </Select>
            <ErrorMessage component={TextError} name={name} />
          </FormControl>
        );
      }}
    </Field>
  )
}

export default SelectField
